import React from 'react';
import './BookingPage.css';

import { PageTitle } from '../../../components';
import { BookTable } from '../../../sections';



const BookingPage = () => {

  return (

    <div className='booking-page'>

      {/* Page Title */}
      <PageTitle title={'Booking'} page={'Booking'} />

      {/* Booking Table Form */}
      <BookTable />

    </div>

  );

}

export default BookingPage;